import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { KnownLockup } from "./Brand";
import { roleLabel, roleText, useOrg } from "./org";

const COPY = {
  owner: ["Set up your church and begin connecting people.", ["Add your people or connect Planning Center.", "Invite your pastors and care team.", "Choose your church's Care Rhythm in Settings."]],
  pastor: ["See how care is moving and where attention is needed.", ["Overview shows coverage, gaps and overdue follow-ups.", "Assign people and care needs to your team.", "Today shows who needs you right now."]],
  director: ["Coordinate care, support leaders, and follow up on assignments.", ["Assign care actions to leaders on your team.", "Overview shows open and overdue assignments.", "Choose who is each person's Assigned Care Leader."]],
  leader: ["See your people, record care, and keep follow-ups moving.", ["Today shows who needs you.", "Log a call, text or visit in a few taps.", "Pick a next step so care keeps moving."]],
  admin: ["Manage people, team access, and church settings.", ["Keep the people directory up to date.", "Invite your team and manage their access.", "Adjust church settings and Care Groups."]],
};

export const FirstWelcome = () => {
  const { me, membership, api, reload } = useOrg();
  const [busy, setBusy] = useState(false);
  const [lead, points] = COPY[membership.role] || COPY.leader;
  const first = me.user.name.split(" ")[0];
  const enter = () => { setBusy(true); api("/me/welcome-seen", { method: "POST" }).finally(() => reload()); };
  return (
    <div className="min-h-screen bg-paper flex flex-col" data-testid="first-welcome">
      <div className="px-6 sm:px-10 pt-8 flex items-center justify-between">
        <KnownLockup size="sm" />
        <button disabled={busy} onClick={enter} className="t-meta py-3 hover:text-ink" data-testid="first-welcome-skip">Skip</button>
      </div>
      <main className="flex-1 flex items-center px-6 sm:px-10 py-12">
        <div className="max-w-xl w-full mx-auto">
          <p className="t-label flex items-center gap-3"><span className="brand-rule" />{membership.org_name}</p>
          <h1 className="t-greeting mt-5" data-testid="first-welcome-title">Welcome, {first}.</h1>
          <p className="t-lead mt-4" data-testid="first-welcome-role">You're joining as <span className="text-ink font-semibold">{roleLabel(membership, membership.role)}</span>. {roleText(membership, lead)}</p>
          <ul className="mt-8 space-y-3" data-testid="first-welcome-points">
            {points.map((p) => <li key={p} className="flex gap-3 t-body"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-[color:var(--clay)] shrink-0" />{roleText(membership, p)}</li>)}
          </ul>
          <button disabled={busy} onClick={enter} className="btn btn-primary btn-lg mt-10" data-testid="first-welcome-enter">Enter KNOWN <ArrowRight size={18} /></button>
        </div>
      </main>
    </div>
  );
};
